import { Component, EventEmitter, OnInit, Output, TemplateRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { NgbDateStruct, NgbCalendar, NgbDateParserFormatter, NgbModalRef, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { GridApi, ColumnApi, ColDef, FilterChangedEvent, FilterModifiedEvent, FilterOpenedEvent, GridReadyEvent, PaginationChangedEvent, RowClickedEvent } from 'ag-grid-community';
import * as FileSaver from 'file-saver';
import { AlertService } from 'src/app/_services/alert.service';
import { MenusService } from 'src/app/_services/menu.service';
import { PiiCellRendererComponent } from 'src/app/common/pii-cell-renderer.component';
import { environment } from 'src/environments/environment';
import { TransactionMasterService } from '../fraud-prevention/transaction-master-rule/transaction-master-service';
import { Location } from "@angular/common";
import * as XLSX from 'xlsx';
import { FormGroup, FormControl, Validators, FormBuilder, AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ModalComponent } from 'src/app/common/modal/modal.component';
import { ModalConfig } from 'src/app/common/modal/modal.config';
import { log } from 'console';
import { ExportTrackingService } from 'src/app/_services/export-tracking.service';
const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
const { defaultPageSizeArr, defaultPageSize } = environment;
export interface OnHoldFilter {
  "pageRecords"?: number;
  "pageNumber"?: number;
  "status"?: string;
  "processedBy"?: string;
  "senderId"?: string;
}
@Component({
  selector: 'app-vat-invoice',
  templateUrl: './vat-invoice.component.html',
  styleUrls: ['./vat-invoice.component.scss']
})
export class VatInvoiceComponent implements OnInit {

  @ViewChild('modalRequest') private modalRequestComponent: ModalComponent;
  @ViewChild('modalPdfViewer') private modalPdfComponent: ModalComponent;
  @ViewChild('invoiceStatusModal', { static: true }) invoiceStatusModal: TemplateRef<any>;
@Output() closed = new EventEmitter<void>();

  vatInvoiceForm: FormGroup;
  modalConfigRequest: ModalConfig;
  modalPdfViewerRequest: ModalConfig;
  type: string;
  submitted = false;
  permissions: any
  currentDate: any = new Date();
  private gridApi!: GridApi;
  private gridColumnApi!: ColumnApi;
  public rowData: any = [];
  globalSearch: string = '';
  public defaultColDef: ColDef = {
    flex: 1,
    minWidth: 200,
    resizable: true,
    sortable: true,
    filter: false,
    autoHeight: true
  };
  collectionSize: number = 0;
  invoiceStatuses: any[] = [];
  successItems: any[] = [];
  existsItems: any[] = [];
  modalRef: NgbModalRef;
  pageRecords: number = defaultPageSize;
  pageSizeArr: any = defaultPageSizeArr;
  pageNumber: number = 1;
  isQuickFilter: boolean = false;
  accountData: any = [];
  json: any=[];
  settlementData: any = [];
  collectiondata: number = 0;
  totalRecords: any;
  image: any;
  walletMerchantError = false;
  userId: String;
  userWalletId: String;
  status: any;
  mailCheckboxChecked: boolean;
  schedulerGridApi: GridApi;
  schedulerGridColumnApi: ColumnApi;
  manualGridApi: GridApi;
  manualGridColumnApi: ColumnApi;
  processedBy: any;
  public searchFromDate: NgbDateStruct;
  public searchToDate: NgbDateStruct;
  minDate: NgbDateStruct;
  maxDate: NgbDateStruct;
  maxDateFrom: NgbDateStruct;
  settlementId: any;
  merchantId: any;
  walletId: any;
  currentDateTime: string;
  startDateTime: string;
  manualStartDateTime: string = '';
  manualEndDateTime: string = '';
  schedulerStartDateTime: string = '';
  schedulerEndDateTime: string = '';

  filterStartDateTime: string = '';
  filterEndDateTime: string = '';
  endDateTime: string;
  requestId: any;
  invoiceNumber: any;


  public schedulerColumn: ColDef[] = [
    {
      field: 'merchantId',
      lockVisible: true,
      headerName: 'Merchant ID',
    },
    {
      field: 'merchantName',
      lockVisible: true,
      headerName: 'Merchant Name',
    },
    {
      field: 'fileName',
      lockVisible: true,
      headerName: 'File Name',
    },
    {
      field: 'vatInvoiceNumber',
      lockVisible: true,
      headerName: 'Invoice Number',
    },
    {
      field: 'tenure',
      lockVisible: true,
      headerName: 'Tenure'
    },
    {
      field: 'createdDate',
      lockVisible: true,
      headerName: 'Created Date Time'
    },
    {
      field: 'status',
      lockVisible: true,
      headerName: 'Status',
      cellRenderer: (params: any) => {
        if (!params.value) return '';

    const status = params.value.toString().toLowerCase(); // case-insensitive

    let badgeClass = 'badge-secondary'; // default

    if (status === 'pending') {
      badgeClass = 'badge-warning'; // yellow
    } else if (status === 'created' || status === 'success') {
      badgeClass = 'badge-success'; // green
    } else if (status === 'failed') {
      badgeClass = 'badge-danger'; // red
    }

    return `<span class="badge ${badgeClass}">${params.value}</span>`;
  }

    },
    {
      field: 'action',
      headerName: 'Action',
      lockVisible: true,
      width: 120,  // wider to fit two buttons comfortably
      cellRenderer: (params: any) => {
        return `
      <button class="btn bg-danger-custom btn-sm view-pdf me-1" title="View PDF" data-action="view" data-url="${params.data.fileUrl}">
        <i class="feather icon-eye"></i>
      </button>
      <button class="btn bg-danger-custom btn-sm resend-email" title="Resend Email" data-action="resend" data-email="${params.data.email || ''}">
        <i class="feather icon-send"></i>
      </button>
    `;
      },
      onCellClicked: (params: any) => {
        if (!params.event.target) return;
        const target = params.event.target as HTMLElement;

        // Find the closest button element clicked (icon could be target)
        let btn = target.tagName === 'BUTTON' ? target : target.closest('button');

        if (!btn) return;

        const action = btn.getAttribute('data-action');

        if (action === 'view') {
          const url = btn.getAttribute('data-url');
          if (url) {
            this.openPdfModal(url);
            // params.api.gridOptionsWrapper.gridOptions.context.componentParent.openPdfModal(url);
          } else {
            alert("No PDF URL available.");
          }
        } else if (action === 'resend') {
          const email = btn.getAttribute('data-email');
          console.log(params.data.id);
          if (params.data.id) {
            this.transactionService.resetEmailRequest(params.data.id).subscribe((data: any) => {
              if (data.response.data) {
                this.alertService.successAlertWithMessage(data.response.message);
              }
              if (data.response.data == null || data.response.data == "") {
                console.log("No data " + data.response);
                this.alertService.errorAlertWithMessage("Error while sending email");
              }
            });
            // params.api.gridOptionsWrapper.gridOptions.context.componentParent.resendEmail(email, params.data);
          } else {
            alert("No email available.");
          }
        }
      }
    }

  ];

  public manualColumn: ColDef[] = [
    {
      field: 'merchantId',
      lockVisible: true,
      headerName: 'Merchant ID',
    },
    {
      field: 'merchantName',
      lockVisible: true,
      headerName: 'Merchant Name',
    },
    {
      field: 'fileName',
      lockVisible: true,
      headerName: 'File Name',
    },
    {
      field: 'vatInvoiceNumber',
      lockVisible: true,
      headerName: 'Invoice Number',
    },
    {
      field: 'tenure',
      lockVisible: true,
      headerName: 'Tenure'
    },
    {
      field: 'requestDate',
      lockVisible: true,
      headerName: 'Request Date'
    },
    {
      field: 'requestedBy',
      lockVisible: true,
      headerName: 'Request By'
    },
    {
      field: 'createdDate',
      lockVisible: true,
      headerName: 'Created Date Time'
    },
    {
      field: 'status',
      lockVisible: true,
      headerName: 'Status',
      cellRenderer: (params: any) => {
      if (!params.value) return '';

    const status = params.value.toString().toLowerCase(); // case-insensitive

    let badgeClass = 'badge-secondary'; // default

    if (status === 'pending') {
      badgeClass = 'badge-warning'; // yellow
    } else if (status === 'created' || status === 'success') {
      badgeClass = 'badge-success'; // green
    } else if (status === 'failed') {
      badgeClass = 'badge-danger'; // red
    }

    return `<span class="badge ${badgeClass}">${params.value}</span>`;
  
      }

    },
    {
      field: 'action',
      headerName: 'Action',
      lockVisible: true,
      width: 120,  // wider to fit two buttons comfortably
      cellRenderer: (params: any) => {
        return `
      <button class="btn bg-danger-custom btn-sm view-pdf me-1" title="View PDF" data-action="view" data-url="${params.data.fileUrl}">
        <i class="feather icon-eye"></i>
      </button>
      <button class="btn bg-danger-custom btn-sm resend-email" title="Resend Email" data-action="resend" data-email="${params.data.email || ''}">
        <i class="feather icon-send"></i>
      </button>
    `;
      },
      onCellClicked: (params: any) => {
        if (!params.event.target) return;
        const target = params.event.target as HTMLElement;

        // Find the closest button element clicked (icon could be target)
        let btn = target.tagName === 'BUTTON' ? target : target.closest('button');

        if (!btn) return;

        const action = btn.getAttribute('data-action');

        if (action === 'view') {
          const url = btn.getAttribute('data-url');
          if (url) {
            this.openPdfModal(url);
            // params.api.gridOptionsWrapper.gridOptions.context.componentParent.openPdfModal(url);
          } else {
            alert("No PDF URL available.");
          }
        } else if (action === 'resend') {
          const email = btn.getAttribute('data-email');
          console.log(params.data.id);
          if (params.data.id) {
            this.transactionService.resetEmailRequest(params.data.id).subscribe((data: any) => {
              if (data.response.data) {
                this.alertService.successAlertWithMessage(data.response.message);
              }
              if (data.response.data == null || data.response.data == "") {
                console.log("No data " + data.response);
                this.alertService.errorAlertWithMessage("Error while sending email");
              }
            });
            // params.api.gridOptionsWrapper.gridOptions.context.componentParent.resendEmail(email, params.data);
          } else {
            alert("No email available.");
          }
        }
      }
    }

  ];

  Resultdata: any;
  merchant: any;
  constructor(private alertService: AlertService, private location: Location, private menuService: MenusService, private ngbCalender: NgbCalendar, private ngbDateParserFormatter: NgbDateParserFormatter, private transactionService: TransactionMasterService, private router: Router, private _FB: FormBuilder, private modalService: NgbModal, private exportTrackingService : ExportTrackingService  ) {
    this.maxDateFrom = this.ngbCalender.getToday();
    this.maxDate = this.ngbCalender.getToday();
    const now = new Date();
    this.currentDateTime = now.toISOString().slice(0, 16);

  }




  async ngOnInit(): Promise<void> {
    console.log("calling");
    const now = new Date();

    this.currentDateTime = now.toISOString().slice(0, 16);
    // this.getOnHoldReport();
    // this.getVatInvoiceRequestedReport();
    const path = this.location.prepareExternalUrl(this.location.path());
    console.log(path)
    this.permissions = this.menuService.getPermissions(path);
    console.log(this.permissions)
    if (this.permissions == null || this.permissions == '' || !this.permissions) {
      this.alertService.errorAlert({
        title: "No Access",
        backdrop: true,
        toast: true,
        timer: 1500
      })
      await this.router.navigateByUrl('/');
    }

    this.vatInvoiceForm = this._FB.group(
      {
        fromDate: ['', Validators.required],
        toDate: ['', [Validators.required]]
      },

    );

    this.modalConfigRequest = {
      modalTitle: "VAT Request",
      modalSize: 'lg',
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

    this.modalPdfViewerRequest = {
      modalTitle: "Customer Screening Report",
      modalSize: 'xl',
      css: "min-height: 500px!important",
      hideDismissButton(): boolean {
        return true
      },
      hideCloseButton(): boolean {
        return true
      }
    }

  }
  get vatInvoiceFormControls() {
    return this.vatInvoiceForm.controls;
  }

  async vatRequest() {
      this.userId="";
    this.userWalletId="";
    this.startDateTime="";
    this.endDateTime="";
    this.mailCheckboxChecked=false;
    return await this.modalRequestComponent.open();
  }

 
  vatRequestClose() {
    this.userId="";
    this.userWalletId="";
    this.startDateTime="";
    this.endDateTime="";
    this.mailCheckboxChecked=false;
    return this.modalRequestComponent.close();
  }

  submitRequest() {

    console.log("Form Values:");
    console.log("MerchantId:", this.userId);
    console.log("WalletId:", this.userWalletId);

    console.log("From Date & Time:", this.startDateTime);
    console.log("To Date & Time:", this.endDateTime);

    //  let fromDateTimestamp = this.startDateTime;
    //     let toDateTimestamp = this.endDateTime;

    this.submitted = true;

    const wallet = this.userWalletId?.trim();
    const merchant = this.userId?.trim();

    // Either wallet or merchant must be present
    this.walletMerchantError = !wallet && !merchant;

    // Start and end date must be present
    if (this.walletMerchantError || !this.startDateTime || !this.endDateTime) {
      return; // stop submission — errors will display
    }
    let fromDateTimestamp = new Date(this.startDateTime).toISOString();
    let toDateTimestamp = new Date(this.endDateTime).toISOString();
    let mailTrigger = this.mailCheckboxChecked;

    let form = {
      "merchantId": this.userId,
      "walletId": this.userWalletId,
      "startDateTime": fromDateTimestamp,
      "endDateTime": toDateTimestamp,
      "triggerEmail": mailTrigger
    }
    this.transactionService.createVatRequest(form).subscribe({
      next: (response: any) => {
        this.vatRequestClose();
        if (Array.isArray(response.response.data)) {
          this.openInvoiceStatusModal(response.response.data);
          this.modalConfigRequest.closeButtonLabel;
        } else {
          this.vatRequestClose();
          this.alertService.errorAlertWithMessage(response.response.message);
        }
      },
      error: (err: any) => {
        this.vatRequestClose();
        this.alertService.errorAlert(err.message || 'Failed to create VAT request.');

      }
    });


    // Additional processing or validation can go here
  }

  allowOnlyNumbers(event: KeyboardEvent): boolean {
    const charCode = event.key.charCodeAt(0);
    return charCode >= 48 && charCode <= 57; // digits 0-9
  }

  allowAlphaNumeric(event: KeyboardEvent): boolean {
    const regex = /^[a-zA-Z0-9]$/;
    return regex.test(event.key);
  }

  getOnHoldReport() {

    let fromDateTimestamp = this.startDateTime;
    let toDateTimestamp = this.endDateTime;
    if (this.startDateTime != null && this.startDateTime != "" && this.endDateTime != null && this.endDateTime != "") {


      // Format datetime correctly
      fromDateTimestamp = fromDateTimestamp.replace('T', ' ') + ':00';
      toDateTimestamp = toDateTimestamp.replace('T', ' ') + ':00';

      console.log(fromDateTimestamp)
      console.log(toDateTimestamp)

      console.log("api called " + toDateTimestamp);
    }
    this.transactionService.getVatInvoiceReportScheduler(this.pageNumber - 1, this.pageRecords, fromDateTimestamp, toDateTimestamp, this.merchantId, this.walletId, this.requestId, this.invoiceNumber, this.type).subscribe((data: any) => {

      console.log(data.response.data.content);
      this.rowData = data.response.data.content;
      this.collectiondata = data.response.data.content
      this.collectionSize = data.response.data.totalElements
      this.totalRecords = data.response.data.totalElements
      if (data.response.data.content.length == 0) {
        console.log("No data");
        this.alertService.errorAlertWithMessage("No records present");
      }
    })
  }


  onStartDateTimeChange(): void {
    const now = new Date();
    let startDate = new Date(this.filterStartDateTime);

    if (isNaN(startDate.getTime())) {
      // if user cleared input → reset to now
      startDate = now;
    }

    // normalize to correct format
    this.filterStartDateTime = this.formatDateForDatetimeLocal(
      startDate > now ? now : startDate
    );

    if (this.filterEndDateTime) {
      let endDate = new Date(this.filterEndDateTime);
      if (isNaN(endDate.getTime()) || endDate < startDate) {
        endDate = startDate;
      }
      this.filterEndDateTime = this.formatDateForDatetimeLocal(endDate);
    } else {
      this.filterEndDateTime = this.filterStartDateTime;
    }

    this.vatInvoiceForm.get('fromDate')?.setValue(this.filterStartDateTime);
    this.vatInvoiceForm.get('toDate')?.setValue(this.filterEndDateTime);
  }

  onRequestStartDateTimeChange(): void {
    const now = new Date();
    let startDate = new Date(this.startDateTime);

    if (isNaN(startDate.getTime())) {
      // if user cleared input → reset to now
      startDate = now;
    }

    // normalize to correct format
    this.startDateTime = this.formatDateForDatetimeLocal(
      startDate > now ? now : startDate
    );

    if (this.endDateTime) {
      let endDate = new Date(this.endDateTime);
      if (isNaN(endDate.getTime()) || endDate < startDate) {
        endDate = startDate;
      }
      this.endDateTime = this.formatDateForDatetimeLocal(endDate);
    } else {
      this.endDateTime = this.startDateTime;
    }

    this.vatInvoiceForm.get('fromDate')?.setValue(this.startDateTime);
    this.vatInvoiceForm.get('toDate')?.setValue(this.endDateTime);
  }
  formatDateForDatetimeLocal(date: Date): string {
    const yyyy = date.getFullYear();
    const mm = ('0' + (date.getMonth() + 1)).slice(-2);
    const dd = ('0' + date.getDate()).slice(-2);
    const hh = ('0' + date.getHours()).slice(-2);
    const min = ('0' + date.getMinutes()).slice(-2);
    return `${yyyy}-${mm}-${dd}T${hh}:${min}`;
  }


  onFilterStartDateTimeChange(): void {
    const now = new Date();
    let startDate = new Date(this.filterStartDateTime);

    if (startDate > now) {
      this.filterStartDateTime = this.formatDateForDatetimeLocal(now);
    } else {
      this.filterStartDateTime = this.formatDateForDatetimeLocal(startDate);
    }

    if (this.filterEndDateTime) {
      const endDate = new Date(this.filterEndDateTime);
      if (endDate < startDate) {
        this.filterEndDateTime = this.filterStartDateTime;
      }
    }

    this.vatInvoiceForm.get('fromDate')?.setValue(this.filterStartDateTime);
    this.vatInvoiceForm.get('toDate')?.setValue(this.filterEndDateTime);

    this.vatInvoiceForm.get('fromDate')?.markAsTouched();
    this.vatInvoiceForm.get('toDate')?.markAsTouched();

    this.vatInvoiceForm.get('fromDate')?.updateValueAndValidity();
    this.vatInvoiceForm.get('toDate')?.updateValueAndValidity();
  }

  openPdfModal(pdfUrl: string) {
    console.log("pdf url " + pdfUrl);

    // Open modal logic here, e.g.
    this.image = pdfUrl;
    this.modalPdfComponent.open();
    // Use your modal service or flag to show PDF viewer modal with selectedPdfUrl
  }

  onEndDateTimeChange(): void {
    const now = new Date();

    if (this.endDateTime && new Date(this.endDateTime) > now) {
      const currentDateTime = now.toISOString().slice(0, 16);
      this.vatInvoiceForm.get('toDate')?.reset(currentDateTime);
      this.vatInvoiceForm.get('toDate')?.updateValueAndValidity();
    }

    if (this.endDateTime && new Date(this.endDateTime) < new Date(this.startDateTime)) {
      this.endDateTime = this.startDateTime;
    }
  }
  onRequestEndDateTimeChange(): void {
    const now = new Date();

    if (this.endDateTime && new Date(this.endDateTime) > now) {
      const currentDateTime = now.toISOString().slice(0, 16);
      this.vatInvoiceForm.get('toDate')?.reset(currentDateTime);
      this.vatInvoiceForm.get('toDate')?.updateValueAndValidity();
    }

    if (this.endDateTime && new Date(this.endDateTime) < new Date(this.startDateTime)) {
      this.endDateTime = this.startDateTime;
    }
  }
  getVatInvoiceRequestedReport() {
    let fromDateTimestamp = this.filterStartDateTime;
    let toDateTimestamp = this.filterEndDateTime;
    if (this.filterStartDateTime != null && this.filterStartDateTime != "" && this.filterEndDateTime != null && this.filterEndDateTime != "") {


      // Format datetime correctly
      fromDateTimestamp = fromDateTimestamp.replace('T', ' ') + ':00';
      toDateTimestamp = toDateTimestamp.replace('T', ' ') + ':00';

      console.log(fromDateTimestamp)
      console.log(toDateTimestamp)

      console.log("api called");
    }
    this.transactionService.getVatInvoiceReportRequested(this.pageNumber - 1, this.pageRecords, fromDateTimestamp, toDateTimestamp, this.merchantId, this.walletId, this.requestId, this.invoiceNumber, this.type).subscribe((data: any) => {
      console.log(data.response.data.content);
      this.rowData = data.response.data.content;
      this.collectiondata = data.response.data.content
      this.collectionSize = data.response.data.totalElements
      this.totalRecords = data.response.data.totalElements
      if (data.response.data.content.length == 0) {
        console.log("No data");
        this.alertService.errorAlertWithMessage("No records present");
      }
    })
  }

  onFilterChange(param: FilterChangedEvent | any) {

  }

  onSortChange(event: any) {
    // console.log("==Sort===>", event);
  }

  onFilterModified(param: FilterModifiedEvent | any) {
  }

  onFilterOpened(param: FilterOpenedEvent | any) {
    // console.log("onFilterOpened----->", param);
  }


  // onGridReady(params: GridReadyEvent) {
  //   // this.gridApi = params.api;
  //   // this.gridColumnApi = params.columnApi;
  //   // this.gridApi.showLoadingOverlay();
  //   // const allColumnIds: (string | Column)[] = [];
  //   // params?.columnApi?.getColumns()?.forEach((column) => {
  //   //   allColumnIds.push(column.getId());
  //   // });
  //   // params?.columnApi?.autoSizeColumns(allColumnIds, false);
  // }
  openInvoiceStatusModal(statuses: any[]) {
    this.invoiceStatuses = statuses;
    this.successItems = statuses.filter(s => s.status?.toLowerCase() === 'success');
    this.existsItems = statuses.filter(s => s.status?.toLowerCase() === 'exists');

    this.modalRef = this.modalService.open(this.invoiceStatusModal, {
      centered: true,
      backdrop: true,
      keyboard: true,
      size: 'lg'
    });

    this.modalRef.result.then(
      (result) => console.log(`Modal closed with: ${result}`),
      () => console.log('Modal dismissed')
    );
  }

  formatDate(period: string): string {
    const [fromDateISO, toDateISO] = period.split('-').map(s => s.trim());
    const fromDate = new Date(fromDateISO);
    const toDate = new Date(toDateISO);
    const pad = (n: number) => String(n).padStart(2, '0');
    const formatDateTime = (d: Date) =>
      `${pad(d.getDate())}/${pad(d.getMonth() + 1)}/${d.getFullYear()} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    return `${formatDateTime(fromDate)} - ${formatDateTime(toDate)}`;
  }

  copyToClipboard(text: string) {
    navigator.clipboard.writeText(text).then(() => {
      this.alertService.successAlert(`Copied! : ${text}`);
    }, () => {
      this.alertService.errorAlertWithMessage('Failed to copy text');
    });
  }
  // getDataByType(type: any) {
  //   this.type = type;
  //   if (this.type === 'SCHEDULER') {
  //     this.getOnHoldReport();       // Load data for Monthly Invoice tab
  //   } else if (this.type === 'MANUAL') {
  //     this.getVatInvoiceRequestedReport();  // Load data for Invoice Request tab
  //   }

  // }

  onPageSizeChanges(eve: any) {
    this.pageNumber = 1;
    if (this.type === 'SCHEDULER') {
      this.getOnHoldReport();       // Load data for Monthly Invoice tab
    } else if (this.type === 'MANUAL') {
      this.getVatInvoiceRequestedReport();  // Load data for Invoice Request tab
    }

  }

  onPaginationChange(param: PaginationChangedEvent | any) {
    this.pageNumber = param;
    if (this.type === 'SCHEDULER') {
      this.getOnHoldReport();       // Load data for Monthly Invoice tab
    } else if (this.type === 'MANUAL') {
      this.getVatInvoiceRequestedReport();  // Load data for Invoice Request tab
    }

  }



  private saveAsExcelFile(buffer: any, fileName: string): void {
    const data: Blob = new Blob([buffer], {
      type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName);
  }

  public gridOptions: any = {
    context: { componentParent: this }, // <-- THIS fixes your undefined error
    rowSelection: 'single',
    pagination: true,
    paginationPageSize: defaultPageSize,
  };

  // public exportAsExcelFile(): void {
  //   const excelFileName: string = 'onhold _report';
  //   this.getOnHoldReport();
  //   let tempRec: any = [];
  //   tempRec = this.schedulerColumn.filter((col: any) => {
  //     const column: any = this.gridColumnApi.getColumn(col?.field);
  //     return column.visible && !(col?.field == "actions")
  //   });
  //   let keysToMatch: any = [];
  //   tempRec.map((col: any) => keysToMatch.push(col.field));
  //   let jsonData = this.findMatchingObjects(keysToMatch);
  //   const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
  //     header: [...tempRec.map((col: any) => col.headerName)]
  //   });
  //   const wb = XLSX.utils.book_new();
  //   XLSX.utils.sheet_add_aoa(worksheet, [[...tempRec.map((col: any) => col.headerName)]]);
  //   XLSX.utils.sheet_add_json(worksheet, jsonData, { origin: 'A2', skipHeader: true });
  //   XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');
  //   const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
  //   this.saveAsExcelFile(excelBuffer, excelFileName);
  // }

  public exportAsExcelFile(): void {
    const excelFileName: string = 'invoice_report_'+ new Date().getTime() + EXCEL_EXTENSION;
    // this.getOnHoldReport(); // Make sure data is loaded

    let columnApi: ColumnApi;
    let columns: any[];

    if (this.type === 'SCHEDULER') {
      columnApi = this.schedulerGridColumnApi;
      columns = this.schedulerColumn;
    } else if (this.type === 'MANUAL') {
      columnApi = this.manualGridColumnApi;
      columns = this.manualColumn;
    } else {
      console.error('Unknown grid type');
      return;
    }

    if (!columnApi) {
      console.error('Grid Column API is not ready yet!');
      return;
    }

    const visibleCols = columns.filter(col => {
      const column = columnApi.getColumn(col?.field);
      return col?.field !== 'action';
    });

    const keysToMatch = visibleCols.map(col => col.field);
    const jsonData = this.findMatchingObjects(keysToMatch, columnApi); // pass columnApi

    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet([], {
      header: visibleCols.map(col => col.headerName)
    });

    XLSX.utils.sheet_add_aoa(worksheet, [visibleCols.map(col => col.headerName)]);
    XLSX.utils.sheet_add_json(worksheet, jsonData, { origin: 'A2', skipHeader: true });

    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, worksheet, 'Sheet1');

    const excelBuffer: any = XLSX.write(wb, { bookType: 'xlsx', type: 'buffer' });
    this.saveAsExcelFile(excelBuffer, excelFileName);

    this.exportTrackingService.trackExcelExport(
      excelFileName,
      this.rowData.length,
      'VAT_INVOICES',
      this.getCurrentFilters()
    ).subscribe({
      next: (response) => {
        console.log('Product category export tracked in audit logs:', response);
        // Proceed with actual export after audit tracking
        // this.performExcelExport(json, excelFileName);
      },
      error: (error) => {
        console.log('Export tracking completed (audit logged):', error);
        // Proceed with export even if tracking fails since audit was logged by interceptor
        // this.performExcelExport(json, excelFileName);
      }
    });
  }

  private findMatchingObjects(keysToMatch: string[], columnApi: ColumnApi): any[] {
    return this.rowData.map((row: any) => {
      const obj: any = {};
      keysToMatch.forEach(key => {
        // Always check column exists
        const column = columnApi.getColumn(key);
        if (column) {
          obj[key] = row[key];
        }
      });
      return obj;
    });
  }

 private getCurrentFilters(): any {
    return {
      MerchantId: this.merchantId || '',
      WalletId: this.walletId || '',
      VatInvoiceNumber: this.invoiceNumber || '',
      StartDateTime: this.filterStartDateTime|| '',
      endDateTime: this.filterEndDateTime || '',
    };
  }

  // findMatchingObjects(keys: string[]): any[] {
  //   let expData: any = [];
  //   this.rowData.forEach((curr: any) => {
  //     const tempRec: any = {}
  //     keys.forEach((col) => {
  //       const column: any = this.gridColumnApi.getColumn(col);
  //       if (column.visible) {
  //         tempRec[col] = curr[col];
  //       }
  //     })
  //     expData.push(tempRec);
  //   })
  //   return expData;
  // }

  onRowClicked(param: RowClickedEvent | any) {
    // console.log("Row Clicked", param);
  }

  onRowDoubleClicked(param: RowClickedEvent | any) {
    // console.log("Row Double Clicked", param);
  }

  changeDate() {
    this.currentDate = this.searchFromDate
    this.minDate = this.searchFromDate;
    let mmmm = this.ngbDateParserFormatter.format(this.searchFromDate);
  }

  changeEndDate() {
    this.currentDate = this.searchToDate;
    this.maxDateFrom = this.searchToDate;
  }

  onSearchClick() {
    if (this.type === 'SCHEDULER') {
      this.schedulerStartDateTime = this.filterStartDateTime;
      this.schedulerEndDateTime = this.filterEndDateTime;
      this.getOnHoldReport();

    } else if (this.type === 'MANUAL') {
      this.manualStartDateTime = this.filterStartDateTime;
      this.manualEndDateTime = this.filterEndDateTime;
      this.getVatInvoiceRequestedReport();
    } else {
      // No type selected, maybe show alert or do nothing
      console.log('Please select a type');
    }
  }

  getDataByType(type: string) {
    this.type = type;
    this.isQuickFilter = false;
    if (type === 'MANUAL') {
      this.resetFilter();
      // Load saved manual dates into filter fields
      this.filterStartDateTime = this.manualStartDateTime;
      this.filterEndDateTime = this.manualEndDateTime;

      this.getVatInvoiceRequestedReport();
    } else if (type === 'SCHEDULER') {
      this.resetFilter();
      this.filterStartDateTime = this.schedulerStartDateTime;
      this.filterEndDateTime = this.schedulerEndDateTime;
      this.getOnHoldReport();
    }
  }

  onGridReady(event: any, type: string) {
    if (type === 'SCHEDULER') {
      this.schedulerGridApi = event.api;
      this.schedulerGridColumnApi = event.columnApi;
    } else if (type === 'MANUAL') {
      this.manualGridApi = event.api;
      this.manualGridColumnApi = event.columnApi;
    }
  }


  resetFilter(): void {
    this.merchantId = "";
    this.walletId = "";
    this.invoiceNumber = "";
    this.requestId = "";
    this.searchFromDate = { year: 0, month: 0, day: 0, };
    this.searchToDate = { year: 0, month: 0, day: 0, };
    this.filterStartDateTime = "";
    this.filterEndDateTime = "";
    this.manualStartDateTime = "";
    this.manualEndDateTime = "";
    this.schedulerStartDateTime = "";
    this.schedulerEndDateTime = "";
    this.submitted = false;
    // this.isQuickFilter = false;
    // this.vatInvoiceForm.reset();
  }
  get fromDate() {
    return this.vatInvoiceForm.get('fromDate');
  }

  get toDate() {
    return this.vatInvoiceForm.get('toDate');
  }

}

export function dateRangeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const fromDate = control.get('fromDate')?.value;
    const toDate = control.get('toDate')?.value;

    if (fromDate && toDate && new Date(fromDate) > new Date(toDate)) {
      return { 'dateRangeInvalid': true };
    }

    return null; // Return null when validation passes
  };



}
